import styled, { css, keyframes, RuleSet } from 'styled-components';

import { Color, Size, Variant } from './Button';

const COLOR_STYLES = {
  gradient: {
    bg: 'linear-gradient(90deg, #6366f1 0%, #a855f7 100%)',
    text: '#ffffff',
    hovered: 'linear-gradient(90deg, #4f46e5 0%, #9333ea 100%)',
    disabled: '#9ca3af',
  },
  grey: {
    bg: '#6b7280',
    text: '#ffffff',
    hovered: '#4b5563',
    disabled: '#9ca3af',
  },
  green: {
    bg: '#10b981',
    text: '#ffffff',
    hovered: '#059669',
    disabled: '#9ca3af',
  },
};

const SIZE_STYLES: Record<Size, RuleSet<object>> = {
  small: css`
    padding: 5px 16px 4px;
    min-height: 36px;
    font-size: 14px;

    @media (max-width: 600px) {
      min-height: 34px;
    }
  `,
  medium: css`
    padding: 8px 24px 6px;
    min-height: 50px;
    font-size: 18px;

    @media (max-width: 600px) {
      min-height: 46px;
    }
  `,
};

export const Root = styled.button<{
  $color: Color;
  $size: Size;
  $variant: Variant;
  $isFullWidth: boolean;
  $isLoading: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 99px;
  transition: 0.2s;
  cursor: pointer;
  font-weight: 500;
  background: ${(props) => COLOR_STYLES[props.$color].bg};
  color: ${(props) => COLOR_STYLES[props.$color].text};
  ${(props) => SIZE_STYLES[props.$size]};
  ${(props) =>
    props.$isFullWidth &&
    css`
      width: 100%;
    `};

  :hover {
    background: ${(props) => COLOR_STYLES[props.$color].hovered};
  }

  :disabled {
    pointer-events: none;
    background: ${(props) => COLOR_STYLES[props.$color].disabled};
    opacity: 0.6;
  }

  ${(props) =>
    props.$variant === 'outlined' &&
    css`
      background: transparent;
      outline: 2px solid #6366f1;
      outline-offset: -2px;
      color: #6366f1;

      &:hover {
        background: #f3f4f6;
      }

      &:disabled {
        outline-color: #9ca3af;
        background: transparent;
        color: #9ca3af;
      }
    `};
`;

const loader = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
`;

export const Loader = styled.div`
  flex-shrink: 0;
  margin-left: 8px;
  width: 30px;
  height: 30px;
  color: inherit;

  border: 0 solid transparent;
  border-radius: 50%;
  position: relative;
  box-sizing: border-box;

  &:before,
  &:after {
    content: '';
    border: 3px solid currentcolor;
    border-radius: 50%;
    width: inherit;
    height: inherit;
    position: absolute;
    top: 0;
    left: 0;
    animation: ${loader} 1.2s linear infinite;
    opacity: 0;
    box-sizing: border-box;
  }
  &:before {
    animation-delay: 1s;
  }
  &:after {
    animation-delay: 0.5s;
  }
`;
